import { useEffect, useState } from 'react';

const useDetectKeyboardNavigation = () => {
  const [isNavigatingViaKeyboard, setIsNavigatingViaKeyboard] =
    useState<boolean>(false);

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Tab') {
      setIsNavigatingViaKeyboard(true);
    }
  };

  const handleMouseDown = () => {
    setIsNavigatingViaKeyboard(false);
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('mousedown', handleMouseDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return isNavigatingViaKeyboard;
};

export default useDetectKeyboardNavigation;
